module.exports = __webpack_public_path__ + "static/media/order_finalized.94450dda.png";